import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const EventImages = ({ event }) => {
    return (
        <>
            <Swiper
                modules={[Navigation, Pagination]}
                navigation
                pagination={{ clickable: true }}
            >
                {event?.images?.map((img, index) => (
                    <SwiperSlide key={index}>
                        <img src={img.url} alt={`Event image ${index + 1}`} className="modal-image" />
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
};
